export const CncEndpoints = {
  AWAITING_DISPATCH: '/api/admin/logistics/cnc/queue/awaitingDispatch',
  CUSTOMER_AT_BAY: '/api/admin/logistics/cnc/queue/customerAtBay',
};
